import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { invalidateAiListeningProfileData } from 'src/reactQuery/utils/aiListeningProfileCache'
import {
  AiListeningBrandProfileApiService,
  AiListeningErrorEnvelope,
} from 'src/services/aiListeningApi/brandProfile'

interface DeleteVariables {
  competitorId: string
  profileId: string
}

interface UseDeleteAiListeningCompetitorMutationParams {
  onError?: (error: AxiosError<AiListeningErrorEnvelope>) => void
  onSuccess?: () => void
}

export const useDeleteAiListeningCompetitorMutation = ({
  onError,
  onSuccess,
}: UseDeleteAiListeningCompetitorMutationParams = {}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ competitorId, profileId }: DeleteVariables) =>
      AiListeningBrandProfileApiService.deleteCompetitor(
        profileId,
        competitorId
      ),
    onError,
    onSuccess: () => {
      invalidateAiListeningProfileData(queryClient)
      onSuccess?.()
    },
  })
}
